import styled from 'styled-components';
import { LinkButton as BaseLinkButton } from '../../common/components/Button/LinkButton/LinkButton';
import { ThemeColours } from '../../common/styles/ThemeColours';
import { FONT_STACK, FontWeight } from '../../common/styles/constants';

export const Container = styled.div`
  align-items: center;
  background-color: ${ThemeColours.mono100};
  border-bottom: solid 1px #d3dde1;
  box-sizing: border-box;
  display: flex;
  flex-flow: column nowrap;
  padding: 24px 24px 0;
`;

export const Title = styled.p`
  ${FONT_STACK}
  color: ${ThemeColours.black};
  flex: 0 0 auto;
  font-size: 16px;
  font-weight: ${FontWeight.SEMI_BOLD};
  line-height: 24px;
  margin: 0 0 8px;
  text-align: center;
`;

export const Body = styled.p`
  ${FONT_STACK}
  color: ${ThemeColours.mono700};
  flex: 0 0 auto;
  font-size: 16px;
  line-height: 24px;
  margin: 0 0 16px;
  text-align: center;
`;

export const LinkButton = styled(BaseLinkButton)`
  flex: 0 0 auto;
  font-size: 16px;
  height: 40px;
  margin: 0 0 24px;
  width: auto;
`;
